import React from 'react';
import StaticPage from '../components/common/StaticPage';

const PrivacyPolicy = () => (
  <StaticPage title="Privacy Policy">
{`At TechVahini, we respect your privacy.

- We do not collect personal data unless you submit it via contact forms.
- Any data you share is used solely to respond to your queries.
- We do not sell or share your data with third parties.

Cookies: We may use basic analytics to improve our content. You can disable cookies in your browser.

Contact: For privacy concerns, email support@techvahini.com.`}
  </StaticPage>
);

export default PrivacyPolicy;
